@use "../colors.scss" as *;

/* stylelint-disable */
:export {
  background: $color-white;
  sub-background: $color-sub-background;
  slider-background: $color-grey-G;
  borders: $color-border;
  emphasis-text: $color-primary-purple;
  text: $color-primary-black;
  sub-text: $color-grey-C;
  light-text: $color-grey-A;
  readonly-field-text: $color-grey-B;
  header: $color-primary-black;
  links: $color-hyperlink-A;
  hover: $color-primary-purple-hover;
  focus: $color-primary-purple-hover;
  shadow: $color-container-shadow;
  deepest: $color-grey-F;
  primary: $color-primary-purple;
  secondary: $color-primary-purple;
  header-footer: $color-grey-E;
  input-readonly: $color-input-readonly;
  input-readonly-border: $color-input-readonly-border;
  tooltip: $color-tooltip-background-dark;
  info-hover: $color-input-readonly;
  info-active: $color-grey-E;
  icon: $color-grey-A;
  radio-disabled-background: $color-grey-G;

  // Oddities
  sidebar: $color-secondary-purple;
  table-header-background: $color-grey-G;
  table-border: $color-secondary-button-border;
  table-text: $color-grey-A;
  table-disabled-text: $color-grey-B;
  table-header-disabled-background: $color-grey-D;
  table-cell-disabled-background: $color-grey-G;
  table-hover: $color-input-readonly;
  secondary-button-hover: $color-secondary-button-hover;
  dark-secondary-button-hover: $color-secondary-button-hover;
  secondary-button-active: $color-secondary-button-active;
  secondary-button-border: $color-secondary-button-border;
  secondary-button-disabled: $color-secondary-button-border;
  grid-color: $color-grey-D;
  divider: $color-secondary-button-border;
  secondary-button-background: $color-white;
  secondary-links: $color-primary-black;
  info-alert-background: $color-grey-G;
  info-alert-border: $color-secondary-button-border;
  form-control-border: $color-secondary-button-border;
  form-alert-info-icon: $color-grey-B;
  placeholder-text-color: $color-grey-A;
  table-column-selected: $color-green-table-hover;
  header-label-text-color: $color-grey-A;
  slider-radio-button-background: $color-input-readonly;

  // checkbox
  checkbox-border: $color-grey-disabled;
  checkbox-hover-border: $color-grey-border-hover;
  checkbox-checked-background: $color-primary-purple;
  checkbox-checked-hover-background: $color-purple-hover-background;
  checkbox-disabled-checked-background: $color-grey-C;
  checkbox-disabled-border: $color-input-readonly-border;
  checkbox-hover-shadow: $hover-shadow-primary;

  // tabs
  tab-label-selected: $color-primary-black;
  tab-label-unselected: $color-grey-B;
  tab-label-hover: $color-primary-black;

  // dropdown
  dropdown-selected-outline-color: $color-primary-purple-60;
  hover-focus-shadow: $color-primary-purple-shadow;
  dropdown-selected-value-color: $color-grey-E;
  dropdown-background-color: $color-white;
  dropdown-text: $color-primary-black;
  dropdown-item-hover: $color-secondary-button-hover;
  dropdown-hover-background: $color-grey-E;
  dropdown-borders-color: $color-secondary-button-border;
  dropdown-checked-icon-color: $color-primary-purple;
  dropdown-selected-background-color: $color-highlight-purple;

  // draggable list
  draggable-list-item-border: $color-secondary-button-border;
  draggable-list-selected-background: $color-highlight-purple;

  // button
  invisi-clear-button-color: $color-white;
  invisi-clear-button-active-color: $color-grey-C;
  button-delete-active-background: $color-highlight-red;
  button-delete-danger-color: $color-primary-red;
  button-remove-chip: $color-grey-disabled;
  button-toggle-hover: $color-grey-C;

  // statuschip
  status-chip-inprogress: $color-highlight-purple;
  status-chip-ignore-background: $color-grey-B-5;
  status-chip-fail-border: $color-primary-red-30;
  status-chip-fail-background: $color-primary-red-5;
  status-chip-pass-border: $color-secondary-green-30;
  status-chip-cancelled-border: $color-secondary-button-border;
  status-chip-error-border: $color-warning-orange-30;

  //test config tags
  color-tag-background: $color-tag-backgrond;
  color-tag-font: $color-tag-font;
  status-chip-text-color: $color-primary-black;

  //id
  id: $color-grey-A;

  //runtypebadge
  run-type-badge-background-color: $color-grey-E;

  // dialog box
  dialog-box-shadow: 0 2px 4px -2px $color-container-shadow-E, 0 4px 8px -2px $color-container-shadow-C;

  // FormAlert color pair
  color-info: $color-highlight-purple;
  color-success: $color-alert-green-background;
  color-warning: $color-warning-orange-background;
  color-error: $color-alert-red-background;
  color-tip: $color-secondary-blue-10;
  color-info-border: $color-primary-purple;
  color-success-border: $color-secondary-green;
  color-warning-border: $color-warning-orange;
  color-error-border: $color-primary-red;
  color-tip-border: $color-secondary-blue;
  color-info-icon: $color-primary-purple;
  color-success-icon: $color-secondary-green;
  color-warning-icon: $color-warning-orange;
  color-error-icon: $color-primary-red-hover;
  color-tip-icon: $color-secondary-blue;

  color-error-placeholder-background: $color-alert-red-background;

  // drag and drop box
  drag-and-drop-box-on-drag-color: $color-primary-purple-shadow;
  drag-and-drop-box-icon-color: $color-primary-purple-light;

  color-dnd-icon: $color-grey-C;

  // progress flow
  progress-flow-background-color: $color-grey-disabled;
  progress-flow-text-color: $color-grey-B;

  // badge
  badge-default-color: $color-primary-purple-10;
  badge-hover-color: $color-primary-purple-25;
  badge-active-color: $color-primary-purple-40;
  badge-background-color: $color-highlight-purple;
  badge-test-case-text: $color-grey-A;
  badge-tag-background-color: rgba($color-primary-purple, 0.05);

  // test case step
  test-case-global-icon-color: $color-focus-shadow;

  // logs
  log-row-background-initializing: $color-table-log-background-primary-initializing;
  log-row-background-error: $color-table-log-background-primary-error;
  log-row-background-success: $color-table-log-background-primary-success;
  log-row-background-orange: $color-warning-orange-background;
  log-text-initializing: $color-table-log-text-primary-initializing;
  log-text-error: $color-table-log-text-primary-error;
  log-text-success: $color-table-log-text-primary-success;
  log-text-orange: $color-warning-orange;

  // test case tag
  test-case-tag-color: $color-primary-purple-5;

  // notifications event
  notification-events-border: $color-secondary-button-border;

  // test config log
  test-config-log-message-background: $color-input-readonly;
  
  // stop icon
  stop-icon-color: $color-primary-red;

  // alert background color
  information-background-color: $color-highlight-purple;
  information-external-background-color: $color-primary-purple-shadow;
}

/* stylelint-enable */